import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("footer", {
    class: ["anufooter flex items-center justify-center", _ctx.$store.state.toggleMenu ? 'active' : '']
  }, _toDisplayString(`v${$setup.version}`), 3))
}